import { Shield, TrendingUp, Users, Award } from "lucide-react";

const differentials = [
  {
    icon: Shield,
    title: "Copy Trade Seguro",
    description: "Acompanhe suas operações replicadas em tempo real com total transparência e segurança"
  },
  {
    icon: TrendingUp,
    title: "Traders Profissionais",
    description: "Copie operações de traders especializados com histórico comprovado em WIN e WDO"
  },
  {
    icon: Users,
    title: "Replicação Automática",
    description: "Sistema automático que replica todas as operações dos nossos traders profissionais"
  },
  {
    icon: Award,
    title: "Resultados Comprovados",
    description: "Copy trade com foco em rentabilidade sustentável e crescimento consistente"
  }
];

const DifferentialsSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-secondary/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-foreground">
            Por que escolher a <span className="bg-gradient-primary bg-clip-text text-transparent">Karpa Investimentos</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Diferenciais que tornam seus investimentos mais seguros e rentáveis
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentials.map((item, index) => (
            <div 
              key={index} 
              className="bg-card rounded-xl p-6 shadow-card hover:shadow-elegant transition-all duration-300 border border-border hover:border-primary/50 flex flex-col items-center text-center"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-primary rounded-full mb-4">
                <item.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="text-lg font-bold mb-3 text-foreground">
                {item.title}
              </h3>
              <p className="text-muted-foreground text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;